// extracted by mini-css-extract-plugin
export default {"ingredient":"ingredient_ingredient__1ou5G","price":"ingredient_price__jpZ+1","isDragging":"ingredient_isDragging__8jn6d","link":"ingredient_link__2GCv4"};